<template>
    <transition name="slide-up">
        <div v-if="modelValue" class="modal-overlay" @click="handleOverlayClick">
            <div class="modal-sheet" :class="sheetClass" @click.stop>
                <div class="modal-header">
                    <button v-if="showBackButton" class="btn-back" @click="$emit('back')">
                        ← {{ backText }}
                    </button>
                    <button class="btn-close" @click="close">✕</button>
                </div>
                <div class="modal-content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    // Support Vue 2 `v-model` by mapping it to `modelValue` / `update:modelValue`.
    // In Vue 2 v-model expects `value`/`input` by default, but we use `modelValue` for
    // forward-compatibility with Vue 3. Declaring `model` lets `v-model` work in Vue 2
    // with our `modelValue` prop and `update:modelValue` event.
    model: {
        prop: 'modelValue',
        event: 'update:modelValue'
    },
    name: 'BottomSheetModal',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        sheetClass: {
            type: String,
            default: ''
        },
        showBackButton: {
            type: Boolean,
            default: false
        },
        backText: {
            type: String,
            default: 'Back'
        },
        closeOnOverlay: {
            type: Boolean,
            default: true
        }
    },
    emits: ['update:modelValue', 'close', 'back'],
    methods: {
        close() {
            this.$emit('update:modelValue', false);
            this.$emit('close');
        },
        handleOverlayClick() {
            if (this.closeOnOverlay) {
                this.close();
            }
        }
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    overflow: hidden;
}

.modal-sheet {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-height: 85vh;
    background: white;
    border-radius: 18px 18px 0 0;
    display: flex;
    flex-direction: column;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0;
}

.btn-back {
    background: none;
    border: none;
    color: #666;
    font-size: 1rem;
    cursor: pointer;
    padding: 0.5rem;
    transition: color 0.2s;
}

.btn-back:hover {
    color: #333;
}

.btn-close {
    background: none;
    border: none;
    color: #666;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 0.5rem;
    line-height: 1;
    transition: color 0.2s;
}

.btn-close:hover {
    color: #333;
}

.modal-content {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 16px;
    flex: 1;
}

/* Slide-up Transition */
.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.3s ease;
}

.slide-up-enter-from {
    opacity: 0;
}

.slide-up-enter-from .modal-sheet {
    transform: translateY(100%);
}

.slide-up-leave-to {
    opacity: 0;
}

.slide-up-leave-to .modal-sheet {
    transform: translateY(100%);
}

@media (min-width: 768px) {
    .modal-sheet {
        left: 50%;
        transform: translateX(-50%);
        width: 50%;
        max-width: 600px;
    }
}

@media (max-width: 576px) {
    .modal-sheet {
        max-height: 95vh;
        border-radius: 16px 16px 0 0;
    }

    .modal-header {
        padding: 18px 15px 12px;
    }

    .modal-content {
        padding: 16px;
    }
}
</style>